"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconStar = function SvgIconStar(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "star icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Star Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M25.838 5.206l4.53 9.798c.297.64.882 1.088 1.56 1.185l10.307 1.477c1.69.243 2.365 2.419 1.135 3.655l-7.507 7.534a2.2 2.2 0 00-.598 1.917l1.843 10.71c.3 1.757-1.47 3.104-2.973 2.26l-9.17-5.142a1.98 1.98 0 00-1.93 0l-9.17 5.141c-1.503.845-3.273-.502-2.973-2.259l1.843-10.71a2.2 2.2 0 00-.595-1.917L4.63 21.32c-1.23-1.236-.555-3.412 1.135-3.655l10.307-1.477a2.053 2.053 0 001.56-1.185l4.53-9.798a2.003 2.003 0 013.676 0"
  }));
};

var _default = SvgIconStar;
exports.default = _default;